import { memo } from 'react';

export const genericMemo: <T>(
  component: T,
  propsAreEqual?: (prevProps: Readonly<T>, nextProps: Readonly<T>) => boolean
) => T = memo;
